<template>
  <v-dialog
    :value="value"
    max-width="800px"
    @input="(v) => v || close()"
  >
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span>改行で複数のメールが入力可能です。</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-container class="px-3 py-0">
        <v-form
          ref="addEmailForm"
          v-model="addEmailFormValid"
          lazy-validation
        >
          <v-textarea
            v-model="str_mails"
            autocomplete="email"
            outlined
            label="メール"
          ></v-textarea>
        </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click="close">キャンセル</v-btn>
        <v-btn class="primary" @click="save">追加</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "AddMailDialog",
  props: ["value", "mails"],
  data(){
    return {
      str_mails: null,
      addEmailFormValid: true,
    }
  },
  methods: {
    close() {
      this.$refs.addEmailForm.reset();
      this.$emit("input");
    },
    checkDuplicateMail(email, list) {
      for(var x in list) {
        if (list[x].email === email) {
          return true;
        }
      }
      return false;
    },
    save() {
      if (this.str_mails != null) {
        const list_mails = this.str_mails.trim().split(/\r?\n/);
        for (var i in list_mails) {
          if (list_mails[i] != "" && !this.checkDuplicateMail(list_mails[i], this.mails)){
            this.mails.push({ 
              email: list_mails[i],
              id: this.mails.length + 1,
            });
          }
        }
      }
      this.close();
    }
  },
}
</script>
<style scoped>
>>>.v-dialog > .v-card > .v-card__text {
  padding: 0px;
}
>>>.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px;
}
</style>

